<template>
  <div class="regions-container">
    <button v-if="isPhone" class="map-button-fixed" @click="openMapModal">
      <img src="../../images/icons8-map-48-white.png" alt="map icon" class="map-button-icon">
    </button>

    <div class="d-flex flex-column align-items-center regions-header">
      <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class="mb-0 text-center">La France</p>
      <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0 text-center">Autrement</p>
      <p :class="isPhone ? 'merriweather-light-18 mb-1' : 'merriweather-light-24 mb-1'">Explorer la France en <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">invité privilégié</span></p>
      
      <div class="d-flex align-items-start justify-content-center w-100" v-if="!isPhone">
        <img src="../../images/icons8-map-48.png" style="width: 21px; height: 21px;" alt="map icon" class="map-icon">
        <p class="map-link raleway-reg-p15 ml-1" @click="openMapModal">Voir la carte de France</p>
      </div>
        
    </div>

    <!-- Map Modal -->
    <div v-if="showMapModal" class="modal-overlay" @click="closeMapModal">
      <div class="modal-dialog" @click.stop>
        <FranceCard :destinations="destinations" @close="closeMapModal"></FranceCard>
      </div>
    </div>

    <div class="navigation-container">
      <div class="masonry-wrapper" id="masonryContainer">
        <div class="masonry-grid">
          <div
            v-for="(region, index) in filteredRegions"
            :key="region.name"
            class="masonry-item"
            :class="getMosaicClass(index)"
            @click="goToGroup('/destination/'+ region.slug)"
          >
            <div class="region-card">
              <img
                :src="region.photo"
                :alt="region.name"
                class="region-image"
              />
              <h3 class="region-name text-center merriweather-bold-p16 text-uppercase">{{ region.name }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="circle-icon next-slide-button" @click="scroll_right()">
        <img src="../../images/arrow-right.svg" alt="Next" />
      </div>
      <div class="circle-icon previous-slide-button" @click="scroll_left()">
        <img src="../../images/arrow-left.svg" alt="Previous" />
      </div>
    </div>

    <div class="d-flex justify-content-center w-100">
      <button class="hortense-btn-primary" :class="isPhone ? 'mx-5' : ''" @click="goToGroup('/destination/france')">DÉCOUVRIR LA FRANCE</button>
    </div>
  </div>
</template>

<script>
import FranceCard from 'components/destinations/Francecard.vue';

export default {
  name: 'RegionsMasonry',
  components: {
    FranceCard
  },
  props: {
    destinations: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isPhone: window.innerWidth <= 480,
      showMapModal: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.$root.$on('openMapModal', this.openMapModal);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this.$root.$off('openMapModal', this.openMapModal);
  },
  methods: {
    handleResize() {
      this.isPhone = window.innerWidth <= 480;
    },
    getMosaicClass(index) {
      // Pattern for 2-row mosaic with specified widths
      // Row 1: wide (502px), narrow (343px), narrow (343px)
      // Row 2: wide (502px), narrow (343px), wide (502px)
      // Item at index 4 spans both rows (full height)
      const pattern = [
        'wide row1',      // 502px in row 1
        'narrow row1',    // 343px in row 1
        'narrow row2',    // 343px in row 2
        'wide row2',      // 502px in row 2
        'full-height',    // spans both rows
      ];
      return pattern[index % pattern.length];
    },
    scroll_left() {
      let content = document.querySelector("#masonryContainer");
      content.scrollLeft -= 220;
    },
    scroll_right() {
      let content = document.querySelector("#masonryContainer");
      content.scrollLeft += 220;
    },
    openMapModal() {
      this.showMapModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeMapModal() {
      this.showMapModal = false;
      document.body.style.overflow = 'auto';
    },
    goToGroup(url) {
      window.open(url, '_blank');
    }
  },
  computed: {
    franceDestination() {
      return this.destinations.find((destination) => {
        const destinationName = (destination?.name || '').toLowerCase();
        const destinationSlug = (destination?.slug || '').toLowerCase();
        return destinationSlug === 'france' || destinationName === 'france';
      });
    },
    filteredRegions() {
      return this.franceDestination?.regions?.filter(
        (region) => region.photo && region.get_lodgings && region.get_lodgings.length > 0
      ) || [];
    }
  },
};
</script>

<style lang="scss" scoped>
.regions-container {
  position: relative;
  width: 90%;
  margin: 0 auto;
  padding: 40px 20px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

.navigation-container {
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  margin-bottom: 40px;
}

.masonry-wrapper {
  flex: 1;
  overflow: auto;
  padding: 15px;
}

.masonry-grid {
  display: grid;
  grid-template-rows: 280px 280px;
  grid-auto-columns: max-content;
  grid-auto-flow: dense;
  gap: 15px;

  @media screen and (max-width: 768px) {
    grid-template-rows: 238px 238px;  
  }
}

.masonry-item {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
  height: 280px;

  @media screen and (max-width: 768px) {
    height: 238px;
  }

  &.wide {
    width: 504px;
    grid-column-end: span 2;

    @media screen and (max-width: 768px) {
      width: 372px;
    }
  }

  &.narrow {
    width: 307px;
    grid-column: span 1;

    @media screen and (max-width: 768px) {
      width: 263px;
    }
  }

  &.full-height {
    width: 323px;
    grid-row: 1 / 3;
    height: 100%;
  }

  &.row1 {
    grid-row: 1;
  }

  &.row2 {
    grid-row: 2;
  }

  &:hover {
    transform: scale(1.02);
  }
}

.region-card {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.region-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.region-name {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: 30px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  color: white;
  letter-spacing: 1px;
}

.circle-icon {
  width: 35px;
  height: 35px;
  border: 1px solid black;
  background: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  img {
    width: 20px;
  }
}

.previous-slide-button {
  position: absolute;
  top: 50%;
  left: -5%;
  transform: translateY(-50%);
  color: white;
}

.next-slide-button {
  position: absolute;
  top: 50%;
  right: -5%;
  transform: translateY(-50%);
  color: white;
}

.map-link {
  color: #3B6152;
  text-decoration: underline;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.map-link:hover {
  opacity: 0.8;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-dialog {
  background-color: white;
  border-radius: 4px;
  width: 100%;
  max-width: 1400px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Tablet Design */
@media (max-width: 1024px) {
  .modal-dialog {
    max-width: 95vw;
    max-height: 95vh;
  }
}

/* Mobile Design */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 0;
  }

  .modal-dialog {
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
    margin: 0;
  }
}

/* Map Button Fixed */
.map-button-fixed {
  position: absolute;
  left: 0;
  top: 50px;
  transform: translateY(-50%);
  width: 60px;
  height: 51px;
  background: #3B6152 0% 0% no-repeat padding-box;
  border: 1px solid #3B6152;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
  transition: opacity 0.3s ease;
}

.map-button-fixed:hover {
  opacity: 0.9;
}

.map-button-icon {
  width: 27px;
  height: 27px;
}

</style>
